import { render, staticRenderFns } from "./ViewDeliveryDetails.vue?vue&type=template&id=667dc305&scoped=true"
import script from "./ViewDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./ViewDeliveryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667dc305",
  null
  
)

export default component.exports